export const CHECKOUT_URL = 'https://oclusion360-en.impultienda.ar/checkout/'

/** Fires the Meta Pixel InitiateCheckout event, if the pixel is available. */
export function trackInitiateCheckout(): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'InitiateCheckout')
}
